export { pickupDeclarationsRoute } from './constants';
export { PickupDeclarationComponent } from './pickup-declarations.component';
export { PickupDeclarationsModule } from './pickup-declarations.module';
